import { UNMONITORED_INDICATOR } from '../../../NonReact/constants/Common'
import { AgentSelectItem, DeviceSelectItem } from '../Components/Selects/Types'

type PossibleSelectItem = AgentSelectItem | DeviceSelectItem

/**
 * Add the unmonitored indicator to the label of the items that are not monitored.
 *
 * @param itemsPromise - The items to indicate.
 *
 * @returns The items with the unmonitored indicator.
 */
export const indicateUnmonitoredItems = <T extends PossibleSelectItem[]>(itemsPromise: Promise<T>): Promise<T> =>
    itemsPromise.then(
        (items: T): T =>
            items.map(
                (item: PossibleSelectItem): PossibleSelectItem => ({
                    ...item,
                    label: item.original?.OverrideMonitoring ? `${UNMONITORED_INDICATOR} ${item.label}` : item.label
                })
            ) as T
    )
